import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../../../../component/ui/Button';
import InputField from '../../../../../../../component/form/FormInput';
import InputSelect from '../../../../../../../component/inputSelect/InputSelect';
import edit from '../../../../../../../assets/image/edit.svg';
import upload from '../../../../../../../assets/image/upload.svg';
import Modal from '../../../../../../../component/modal/Modal';
import { toast } from 'react-toastify';
import {
	updateOrganizationLogo,
	updatePrimaryContact,
	verifyOrgDomain,
} from '../../../../../../../services/settings/organization';
import { useSelector } from 'react-redux';
import { getDate } from '../../../../../../../utils/dateUtils';

export default function ProfileForm({
	formData,
	primaryContact,
	primaryContactForm,
	setPrimaryContactForm,
	error,
	setError,
	isOpenModal,
	setIsOpenModal,
	cityList,
	languageList,
	fiscalYearList,
	dateFormatList,
	dateSeparatorList,
	timeZoneList,
	stateList,
	industryList,
	handleFormData,
	handleAddressFormData,
	getOrganizationProfileDetail,
	isGstRegEnable,
	setIsGstRegEnable,
	gstForm,
	setGSTForm,
	handleGSTFormData,
}) {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [disabled, setDisabled] = useState(false);
	const [isUpdate, setIsUpdate] = useState(false);
	const [contactError, setContactError] = useState({});
	const [selectedFile, setSelectedFile] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [isEditDomain, setIsEditDomain] = useState(false);
	const [uploadedLogo, setUploadedLogo] = useState(null);
	const fileInputRef = useRef(null);
	const [domain, setDomain] = useState('');

	const handleFileSelect = (file) => {
		if (file && file.type.startsWith('image/')) {
			setSelectedFile(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				const imageUrl = reader.result;
				setUploadedLogo(imageUrl);
			};
			reader.readAsDataURL(file);
		} else {
			toast.error('Please select a valid image file');
		}
	};

	useEffect(() => {
		if (isEditDomain) {
			const timer = setTimeout(() => {
				if (formData.domain.trim() !== '') {
					checkSubDomain(formData.domain);
				}
			}, 500);

			return () => clearTimeout(timer);
		}
	}, [isEditDomain, formData.domain]);

	const checkSubDomain = async (domain) => {
		try {
			const { organisation } = await verifyOrgDomain(domain);
			const { available } = organisation;
			var newError = { ...error };
			if (available?.available) {
				delete newError.domain;
			} else {
				newError.domain = available.message;
			}
			setError(newError);
		} catch (error) { }
	};

	const handleFileInput = (e) => {
		const file = e.target.files[0];
		handleFileSelect(file);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		setIsDragging(false);
	};

	const handleDrop = (e) => {
		if (
			selectedFile === null &&
			(formData.organisation_logo === null || formData.organisation_logo === '')
		) {
			e.preventDefault();
			setIsDragging(false);
			const file = e.dataTransfer.files[0];
			handleFileSelect(file);
		}
	};

	const handleBoxClick = () => {
		if (
			selectedFile === null &&
			(formData.organisation_logo === null || formData.organisation_logo === '')
		) {
			fileInputRef.current.click();
		}
	};
	const handleRemove = (e) => {
		e.stopPropagation();
		setSelectedFile(null);
		setUploadedLogo(null);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
		handleFormData('organisation_logo', null);
	};
	const handleUploadLogo = async (e) => {
		e.stopPropagation();
		try {
			const formData = new FormData();
			formData.append('logo', selectedFile);
			const { organisation } = await updateOrganizationLogo(formData);
			toast.success('Organisation logo uploaded successfully');
			handleFormData('organisation_logo', `${organisation?.organisation_logo}`);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	const handlePrimaryContact = (type, value) => {
		setPrimaryContactForm((prev) => ({
			...prev,
			[type]: value,
		}));
		var newError = { ...contactError };
		if (type === 'name') {
			if (value) {
				if (value === '' || value === null || value === undefined) {
					newError[type] = `Please enter valid contact person in the field`;
				} else {
					delete newError[type];
				}
			} else {
				delete newError[type];
			}
		}
		if (type === 'phone_number') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					newError[type] = `Please enter valid phone number`;
				} else {
					delete newError[type];
				}
			} else {
				delete newError[type];
			}
		}
		if (type === 'email') {
			if (value) {
				if (validateEmail(value)) {
					delete newError[type];
				} else {
					newError[type] = 'Please enter valid email address';
				}
			} else {
				delete newError[type];
			}
		}
		setContactError(newError);
	};
	const checkValidation = () => {
		var newError = { ...contactError };
		if (
			primaryContact?.name === '' ||
			primaryContact?.name === null ||
			primaryContact?.name === undefined
		) {
			newError.name = 'Please enter contact person in thw field';
		} else {
			delete newError.name;
		}
		if (Object.keys(newError).length > 0) {
			setContactError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleUpdatePrimaryContact = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Update primary contact failed ! Please fill required fields.');
		} else {
			try {
				setIsUpdate(true);
				const res = await updatePrimaryContact(primaryContactForm);
				if (res.success === true) {
					setIsOpenModal(false);
					toast.success(res.message);
					getOrganizationProfileDetail();
				} else {
					toast.error(res.message || 'Something went wrong');
				}
			} catch (e) {
				toast.error(e.message);
			} finally {
				setIsUpdate(false);
			}
		}
	};

	useEffect(() => {
		const domainName = new URL(window.location.href).hostname;
		setDomain(domainName);
	}, []);

	return (
		<div
			style={{
				height: 'calc(100vh - 120px)',
				overflowX: 'hidden',
				overflowY: 'auto',
				paddingBottom: '10rem',
			}}
		>
			<div className="p-4">
				<div className="row align-items-center my-4">
					{/* Upload Section */}
					<div className="col-4 col-xl-2 text-sm font-medium">Upload Your Organization Logo</div>
					<div className="col-8 col-xl-6 my-2">
						<div
							className={`upload-section text-center p-4 ${isDragging ? 'border-primary bg-light' : ' cursor-pointer'
								}`}
							onClick={handleBoxClick}
							onDragOver={handleDragOver}
							onDragLeave={handleDragLeave}
							onDrop={handleDrop}
						>
							<input
								ref={fileInputRef}
								type="file"
								accept="image/*"
								onChange={handleFileInput}
								style={{ display: 'none' }}
							/>
							{(formData.organisation_logo !== '' && formData.organisation_logo !== null) ||
								uploadedLogo ? (
								<div>
									<img
										src={
											formData.organisation_logo !== null && formData.organisation_logo !== ''
												? formData.organisation_logo
												: uploadedLogo
										}
										alt="Organization Logo"
										style={{ maxWidth: '150px', maxHeight: '150px' }}
										className="mb-2"
									/>
									<div className="fw-medium mb-2">{selectedFile?.name}</div>
									<div className="text-muted small mb-2">
										{selectedFile && `${(selectedFile.size / 1024).toFixed(2)} KB`}
									</div>
									<div className="d-flex align-item-center gap-4 justify-content-center">
										<Button
											className="btn btn-outline-danger btn-sm cursor-pointer px-4"
											button="Remove"
											onClick={handleRemove}
										></Button>
										{formData.organisation_logo === null || formData.organisation_logo === '' ? (
											<Button
												className="btn btn-primary btn-sm cursor-pointer px-4"
												button="Upload"
												onClick={handleUploadLogo}
											></Button>
										) : (
											''
										)}
									</div>
								</div>
							) : (
								<div className="p-4">
									<img
										src={upload}
										alt="search-icon"
										width="24"
										height="24"
										className="rounded-circle me-2"
									/>
									<div className="text-sm font-medium my-2">Drag And Drop Here</div>
									<div className="text-sm font-medium my-2">Or Click to Browse</div>
									<div className="fs-5 text-gray">No File Chosen</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="row align-items-center my-1">
					<div className="d-flex col-4 col-xl-2 gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Organization Name</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-8 col-xl-6">
						<InputField
							label=""
							placeholder="Organization Name"
							type="text"
							required={true}
							value={formData.organisation_name}
							onChange={(value) => handleFormData('organisation_name', value, true)}
							disabled={disabled}
							error={error?.organisation_name}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="d-flex col-4 col-xl-2  gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Industry</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-8 col-xl-6">
						<InputSelect
							options={industryList}
							label=""
							placeholder="Select Industry"
							error={error?.industry_id}
							returnInputValue={false}
							value={formData.industry_id}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('industry_id', options.key, true)}
						/>
					</div>
				</div>

				<div className="row align-items-start">
					<div className="col-4 col-xl-2 text-sm font-medium my-3">Organization Address</div>
					<div className="col-8 col-xl-6 my-2">
						<div>
							<InputField
								label=""
								placeholder="Address Street 1"
								type="text"
								required={false}
								value={formData?.address?.street_1}
								onChange={(value) => handleAddressFormData('street_1', value)}
								disabled={disabled}
								error={error?.street_1}
							/>
						</div>
						<div className="my-3">
							<InputField
								label=""
								placeholder="Address Street 2"
								type="text"
								required={false}
								value={formData.address?.street_2}
								onChange={(value) => handleAddressFormData('street_2', value)}
								disabled={disabled}
								error={error?.street_2}
							/>
						</div>
						<div className="row align-items-start">
							<div className="col-6">
								<InputSelect
									options={stateList}
									label=""
									placeholder="Select State"
									error={error?.state_id}
									returnInputValue={false}
									value={formData.address?.state_id}
									onChange={(value) => { }}
									onSelect={(options) => {
										handleAddressFormData('state_id', options.key);
									}}
								/>
							</div>
							<div className="col-6 my-2">
								<InputField
									label=""
									placeholder="Zip code"
									type="text"
									required={false}
									value={formData.address?.postal_code}
									onChange={(value) => handleAddressFormData('postal_code', value)}
									disabled={disabled}
									error={error?.postal_code}
								/>
							</div>
						</div>
						<div className="row align-items-start">
							<div className="col-6">
								<InputSelect
									options={cityList}
									label=""
									placeholder="Select City"
									error={error?.city_id}
									returnInputValue={false}
									value={formData.address?.city_id}
									onChange={(value) => { }}
									onSelect={(options) => handleAddressFormData('city_id', options.key)}
								/>
							</div>
							<div className="col-6 my-2">
								<InputField
									label=""
									placeholder="Mobile no"
									type="text"
									required={false}
									value={formData.address.phone_number}
									onChange={(valueData) => {
										var value = valueData?.replace(/[^0-9]/g, '');
										handleAddressFormData('phone_number', value, true);
									}}
									disabled={disabled}
									error={error?.phone_number}
								/>
							</div>
						</div>
						<div className="my-1">
							<div className="input-group mb-3">
								<div className="input-group-append">
									<span
										className="input-group-text font-medium"
										style={{
											minHeight: '3.6rem',
											fontSize: '1.4rem',
											marginLeft: '.1rem',
											minWidth: '5rem',
											justifyContent: 'center',
											color: 'var(--brand-color)',
											borderRadius: ' 8px 0 0 8px',
										}}
									>
										{`${domain}/user/`}
									</span>
								</div>
								<input
									style={{
										borderRadius: '8px',
										borderTopLeftRadius: '0px',
										borderBottomLeftRadius: '0px',
										border: `1px solid ${error?.domain !== '' && error?.domain !== undefined ? 'red' : 'rgba(85, 91, 103, 0.15)'}`,
										backgroundColor: '#FCFCFC',
										padding: '8px',
										borderLeft: '0',
									}}
									type="text"
									className={`form-control ${user?.settings?.general_preferences?.enable_auto_capitalize_input?.value ? 'uppercase' : 'capitalize'}`}
									id="inlineFormInputGroup"
									placeholder="domain"
									onChange={(e) => {
										handleFormData('domain', e?.target?.value, true);
										setIsEditDomain(true);
									}}
									value={formData.domain}
									label=""
									name={'sub_domain'}
									error={error?.domain}
								/>
							</div>
							{error && (
								<div
									className="error-text"
									style={{
										color: 'red',
										fontSize: '12px',
										// marginBottom: '10px',
									}}
								>
									{error?.domain}
								</div>
							)}
							{/* <InputField
								label=""
								placeholder="domain"
								type="text"
								required={true}
								value={formData.domain}
								onChange={(value) => handleFormData('domain', value)}
								disabled={disabled}
								error={error?.domain}
							/> */}
						</div>
					</div>
				</div>
				<div className="d-flex align-items-center">
					<div className="col-4 col-xl-2 text-sm font-medium">Primary Contact</div>
					<div className="col-7 col-xl-6 my-2">
						<div className="d-flex profile-contact py-3">
							<div className="col-8 text-center py-3">
								<div className="fs-5 fw-semibold text-dark">{primaryContact?.name || ''}</div>
								<div className="fs-6 fw-light text-dark text-break px-3">
									{primaryContact.email && `(${primaryContact.email})`}
								</div>
							</div>
							<p style={{ borderRight: '1px solid #000', margin: '0px' }}></p>
							<div className="col-4 text-center py-3">
								<div className="fs-5 fw-semibold text-dark">
									{primaryContact.phone_number && 'Phone'}
								</div>
								<div className="fs-6 fw-light text-dark">{primaryContact.phone_number}</div>
							</div>
						</div>
					</div>
					<div>
						<img
							src={edit}
							alt="search-icon"
							width="24"
							height="24"
							onClick={() => {
								setContactError({});
								setPrimaryContactForm(primaryContact);
								setIsOpenModal(true);
							}}
							className="m-2 cursor-pointer"
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="d-flex col-4 col-xl-2 gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Fiscal Year</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-8 col-xl-6">
						<InputSelect
							options={fiscalYearList}
							label=""
							placeholder="Select Fiscal Year"
							error={error?.fiscal_year}
							returnInputValue={false}
							value={formData.fiscal_year}
							disabled={true}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('fiscal_year', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-4 col-xl-2 text-sm font-medium">Language</div>
					<div className="col-8 col-xl-6">
						<InputSelect
							options={languageList}
							label=""
							placeholder="Select Language"
							error={error?.language}
							returnInputValue={false}
							value={formData.language}
							disabled={true}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('language', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-4 col-xl-2	 text-sm font-medium">Time Zone</div>
					<div className=" col-8 col-xl-6">
						<InputSelect
							options={timeZoneList}
							label=""
							placeholder="Select Time Zone"
							error={error?.time_zone}
							returnInputValue={false}
							value={formData.time_zone}
							disabled={true}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('time_zone', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-4 col-xl-2 text-sm font-medium">Date Format</div>
					<div className="col-5 col-xl-4">
						<InputSelect
							options={dateFormatList}
							label=""
							placeholder="Select Date Format"
							error={error?.date_format}
							returnInputValue={false}
							disabled={false}
							value={formData.date_format}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('date_format', options.value)}
						/>
					</div>
					<div className="col-3 col-xl-2">
						<InputSelect
							options={dateSeparatorList}
							label=""
							placeholder="Select Date Format"
							error={error?.date_separator}
							returnInputValue={false}
							disabled={false}
							value={formData.date_separator}
							onChange={(value) => { }}
							onSelect={(options) => handleFormData('date_separator', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center mt-2 mb-3" data-testid="drug-license-details-section">
					<div className="col-4 col-xl-2 text-sm font-medium">Drug License Number</div>
					<div className="col-8 col-xl-6">
						<InputField
							label=""
							placeholder="Drug License Number"
							type="text"
							required={false}
							value={formData.drug_license_number || ''}
							onChange={(value) => handleFormData('drug_license_number', value)}
							disabled={disabled}
							error={error?.drug_license_number}
							data-testid="drug-license-number-input"
						/>
					</div>
				</div>
				{/* GST Settings Section */}
				<div className="my-3" data-testid="gst-settings-section">
					<div className="text-sm fw-bold text-primary mt-4 mb-3" data-testid="gst-settings-title">
						GST Settings
					</div>

					<div className="row align-items-center py-1 mb-3" data-testid="gst-registration-enable-row">
						<div className="col-4 col-xl-2 text-sm font-medium">GST Registration Enable</div>
						<div className="col-8 col-xl-6 d-flex justify-content-end align-items-center">
							<div className="form-check form-switch m-0 p-0">
								<input
									className="form-check-input cursor-pointer"
									type="checkbox"
									role="switch"
									checked={formData.gst_settings.gst_registration_enable || false}
									onChange={(e) => handleGSTFormData('gst_registration_enable', e.target.checked)}
									data-testid="gst-registration-enable-switch"
								/>
							</div>
						</div>
					</div>

					{formData.gst_settings.gst_registration_enable && (
						<div data-testid="gst-form-fields">
							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">GSTIN</div>
								<div className="col-8 col-xl-6">
									<InputField
										label=""
										placeholder="GSTIN Number"
										type="text"
										value={formData.gst_settings?.gstin || ''}
										onChange={(value) => handleGSTFormData('gstin', value)}
										error={error?.gstin}
										data-testid="gstin-input"
									/>
								</div>
							</div>

							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">Business Legal Name</div>
								<div className="col-8 col-xl-6">
									<InputField
										label=""
										placeholder="Business Legal Name"
										type="text"
										value={formData.gst_settings?.business_legal_name || ''}
										onChange={(value) => handleGSTFormData('business_legal_name', value)}
										error={error?.business_legal_name}
										data-testid="business-legal-name-input"
									/>
								</div>
							</div>

							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">Business Trade Name</div>
								<div className="col-8 col-xl-6">
									<InputField
										label=""
										placeholder="Business Trade Name"
										type="text"
										value={formData.gst_settings?.business_trade_name || ''}
										onChange={(value) => handleGSTFormData('business_trade_name', value)}
										error={error?.business_trade_name}
										data-testid="business-trade-name-input"
									/>
								</div>
							</div>

							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">GST Registration Date</div>
								<div className="col-8 col-xl-6">
									<InputField
										label=""
										placeholder="GST Registration Date"
										type="date"
										value={formData.gst_settings?.gst_registration_date || ''}
										onChange={(value) => handleGSTFormData('gst_registration_date', value)}
										error={error?.gst_registration_date}
										data-testid="gst-registration-date-input"
									/>
								</div>
							</div>

							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">Composition Enable</div>
								<div className="col-8 col-xl-6 d-flex justify-content-end align-items-center">
									<div className="form-check form-switch m-0 p-0">
										<input
											className="form-check-input cursor-pointer"
											type="checkbox"
											role="switch"
											checked={formData.gst_settings?.composition_enable || false}
											onChange={(e) => handleGSTFormData('composition_enable', e.target.checked)}
											data-testid="composition-enable-switch"
										/>
									</div>
								</div>
							</div>

							<div className="row align-items-center py-1 mb-3">
								<div className="col-4 col-xl-2 text-sm font-medium">Composition Scheme</div>
								<div className="col-8 col-xl-6 d-flex justify-content-end align-items-center">
									<div className="form-check form-switch m-0 p-0">
										<input
											className="form-check-input cursor-pointer"
											type="checkbox"
											role="switch"
											checked={formData.gst_settings?.composition_scheme || false}
											onChange={(e) => handleGSTFormData('composition_scheme', e.target.checked)}
											data-testid="composition-scheme-switch"
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
			{isOpenModal && (
				<Modal
					className="profile_model"
					title={`Edit Primary Contact`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
					}}
				>
					<div>
						<div className="my-1">
							<InputField
								label="Contact Person"
								placeholder="Contact Person"
								type="text"
								required={true}
								autoFocus={true}
								value={primaryContactForm.name}
								onChange={(value) => handlePrimaryContact('name', value)}
								disabled={disabled}
								error={contactError?.name}
							/>
						</div>
						<div className="my-1">
							<InputField
								label="Email"
								placeholder="Email Address"
								type="text"
								required={true}
								value={primaryContactForm.email}
								onChange={(value) => handlePrimaryContact('email', value)}
								disabled={true}
								error={contactError?.email}
							/>
						</div>
						<div className="my-1">
							<InputField
								label="Phone"
								placeholder="Phone"
								type="text"
								required={false}
								value={primaryContactForm.phone_number}
								onChange={(valueData) => {
									var value = valueData?.replace(/[^0-9]/g, '');
									handlePrimaryContact('phone_number', value);
								}}
								disabled={disabled}
								error={contactError?.phone_number}
							/>
						</div>
					</div>

					<div className="d-flex align-items-center justify-content-end gap-4 mt-4">
						<Button
							type="button"
							button={`Save`}
							disabled={isUpdate}
							loader={isUpdate}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handleUpdatePrimaryContact()}
						/>
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModal(false)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}
